const commitmentFunctionality = localStorage.getItem("clientData")
  ? JSON.parse(localStorage.getItem("clientData")).commitment_functionality
  : false

const getBehaviorFunctionalityDD = () =>
  localStorage.getItem("clientData")
    ? JSON.parse(localStorage.getItem("clientData")).behavior_functionality_daily_dialogue
    : false

export default [
  // Process
  {
    path: '/organization/process',
    name: 'organization-process-list',
    component: () => import('@/views/organization/process/list/List.vue'),
    meta: {
      pageTitle: commitmentFunctionality ? 'Confirmations List' : 'List all processes',
      breadcrumb: [
        {
          text: commitmentFunctionality ? 'Confirmations' : 'Processes',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/process/add',
    name: 'organization-process-add',
    component: () => import('@/views/organization/process/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Process',
      breadcrumb: [
        {
          text: 'Processes',
          to: '/organization/process',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/process/edit/:id',
    name: 'organization-process-edit',
    component: () => import('@/views/organization/process/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Process',
      breadcrumb: [
        {
          text: 'Processes',
          to: '/organization/process',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Workers
  {
    path: '/organization/workers',
    name: 'organization-worker-list',
    component: () => import('@/views/organization/worker/list/List.vue'),
    meta: {
      pageTitle: 'List all workers',
      breadcrumb: [
        {
          text: 'Workers',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/workers/add',
    name: 'organization-worker-add',
    component: () => import('@/views/organization/worker/add/Add.vue'),
    meta: {
      pageTitle: 'Create a new Worker',
      breadcrumb: [
        {
          text: 'Workers',
          to: '/organization/workers',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/worker/edit/:id',
    name: 'organization-worker-edit',
    component: () => import('@/views/organization/worker/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Worker',
      breadcrumb: [
        {
          text: 'Workers',
          to: '/organization/workers',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Roles
  {
    path: '/organization/role/list',
    name: 'organization-role-list',
    component: () => import('@/views/organization/role/list/List.vue'),
    meta: {
      pageTitle: 'List all roles',
      breadcrumb: [
        {
          text: 'Roles',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/role/add',
    name: 'organization-role-add',
    component: () => import('@/views/organization/role/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Role',
      breadcrumb: [
        {
          text: 'Roles',
          to: '/organization/role/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/role/edit/:id',
    name: 'organization-role-edit',
    component: () => import('@/views/organization/role/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Role',
      breadcrumb: [
        {
          text: 'Roles',
          to: '/organization/role/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Question Types
  {
    path: '/organization/question-type/list',
    name: 'organization-question-type-list',
    component: () => import('@/views/organization/question_type/list/List.vue'),
    meta: {
      pageTitle: 'List all question types',
      breadcrumb: [
        {
          text: 'Question Types',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/question-type/add',
    name: 'organization-question-type-add',
    component: () => import('@/views/organization/question_type/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Question Type',
      breadcrumb: [
        {
          text: 'Question Types',
          to: '/organization/question-type/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/question-type/edit/:id',
    name: 'organization-question-type-edit',
    component: () => import('@/views/organization/question_type/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Question Type',
      breadcrumb: [
        {
          text: 'Question Types',
          to: '/organization/question-type/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Locations
  {
    path: '/organization/location/list',
    name: 'organization-location-list',
    component: () => import('@/views/organization/location/list/List.vue'),
    meta: {
      pageTitle: 'List all locations',
      breadcrumb: [
        {
          text: 'Locations',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/location/add',
    name: 'organization-location-add',
    component: () => import('@/views/organization/location/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Location',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/organization/location/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/location/edit/:id',
    name: 'organization-location-edit',
    component: () => import('@/views/organization/location/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Location',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/organization/location/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  // Physical Locations
  {
    path: '/organization/physical_location/list',
    name: 'organization-physical_location-list',
    component: () => import('@/views/organization/physical_location/list/List.vue'),
    meta: {
      pageTitle: 'List all physical locations',
      breadcrumb: [
        {
          text: 'Physical Locations',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/physical_location/add',
    name: 'organization-physical_location-add',
    component: () => import('@/views/organization/physical_location/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Physical Location',
      breadcrumb: [
        {
          text: 'Physical Locations',
          to: '/organization/physical_location/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/physical_location/edit/:id',
    name: 'organization-physical_location-edit',
    component: () => import('@/views/organization/physical_location/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Physical Location',
      breadcrumb: [
        {
          text: 'Physical Locations',
          to: '/organization/physical_location/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  // Areas
  {
    path: '/organization/area/list',
    name: 'organization-area-list',
    component: () => import('@/views/organization/area/list/List.vue'),
    meta: {
      pageTitle: 'List all areas',
      breadcrumb: [
        {
          text: 'Areas',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/area/add',
    name: 'organization-area-add',
    component: () => import('@/views/organization/area/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Area',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/organization/area/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/area/edit/:id',
    name: 'organization-area-edit',
    component: () => import('@/views/organization/area/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Area',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/organization/area/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  // Feedback Points
  {
    path: '/organization/feedbackPoint/list',
    name: 'organization-feedbackPoint-list',
    component: () => import('@/views/organization/feedback-point/list/List.vue'),
    meta: {
      pageTitle: 'List all feedback points',
      breadcrumb: [
        {
          text: 'Feedback Points',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/feedbackPoint/add',
    name: 'organization-feedbackPoint-add',
    component: () => import('@/views/organization/feedback-point/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Feedback Point',
      breadcrumb: [
        {
          text: 'Feedback Points',
          to: '/organization/feedbackPoint/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/feedbackPoint/edit/:id',
    name: 'organization-feedbackPoint-edit',
    component: () => import('@/views/organization/feedback-point/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Feedback Point',
      breadcrumb: [
        {
          text: 'Feedback Points',
          to: '/organization/feedbackPoint/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  // Department Report
  {
    path: '/habit/department/report',
    name: 'habit-department-report',
    component: () => import('@/views/habit/report/Department.vue'),
    meta: {
      pageTitle: 'Department Report',
      breadcrumb: [
        {
          text: 'Report',
        },
        {
          text: 'Department',
          active: true,
        },
      ],
    },
  },
  // Area/Physical Location Report
  {
    path: '/habit/area-physical_location/report',
    name: 'habit-area-physical_location-report',
    component: () => import('@/views/habit/report/AreaPhysicalLocation.vue'),
    meta: {
      pageTitle: 'Area/Physical Location',
      breadcrumb: [
        {
          text: 'Report',
        },
        {
          text: 'Area/Physical Location',
          active: true,
        },
      ],
    },
  },
  // Question Type Report
  {
    path: '/habit/question-type/report',
    name: 'habit-question-type-report',
    component: () => import('@/views/habit/report/QuestionTypes.vue'),
    meta: {
      pageTitle: 'Adherence by Question Type',
      breadcrumb: [
        {
          text: 'Report',
        },
        {
          text: 'Questions',
          active: true,
        },
      ],
    },
  },
  // Metadata
  {
    path: '/organization/metadata/list',
    name: 'organization-metadata-list',
    component: () => import('@/views/organization/metadata/list/List.vue'),
    meta: {
      pageTitle: 'List all metadata',
      breadcrumb: [
        {
          text: 'Metadata',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/metadata/add',
    name: 'organization-metadata-add',
    component: () => import('@/views/organization/metadata/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Metadata',
      breadcrumb: [
        {
          text: 'Metadata',
          to: '/organization/metadata/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/metadata/edit/:id/:index',
    name: 'organization-metadata-edit',
    component: () => import('@/views/organization/metadata/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Metadata',
      breadcrumb: [
        {
          text: 'Metadata',
          to: '/organization/metadata/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/metadata/upload',
    name: 'organization-metadata-upload',
    component: () => import('@/views/organization/metadata/upload/Upload.vue'),
    meta: {
      pageTitle: 'bulkMetadataUpload',
      breadcrumb: [
        {
          text: 'Metadata',
          to: '/organization/metadata/list',
        },
        {
          text: 'Upload',
          active: true,
        },
      ],
    },
  },

  // Confirmation Planning
  {
    path: '/organization/confirmation-planning',
    name: 'organization-confirmation-planning-list',
    component: () => import('@/views/organization/confirmation-planning/list/List.vue'),
    meta: {
      pageTitle: 'Confirmation Planning',
      breadcrumb: [
        {
          text: 'Planning',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/confirmation-planning/add',
    name: 'organization-confirmation-planning-add',
    component: () => import('@/views/organization/confirmation-planning/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Confirmation Planning',
      breadcrumb: [
        {
          text: 'Planning',
          to: '/organization/confirmation-planning',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/confirmation-planning/edit/:id',
    name: 'organization-confirmation-planning-edit',
    component: () => import('@/views/organization/confirmation-planning/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Confirmation Planning',
      breadcrumb: [
        {
          text: 'Planning',
          to: '/organization/confirmation-planning',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Pending Confirmations
  {
    path: '/organization/pending-confirmations',
    name: 'organization-pending-confirmations',
    component: () => import('@/views/organization/pending-confirmations/list/List.vue'),
    meta: {
      pageTitle: 'List all pending confirmations',
      breadcrumb: [
        {
          text: 'Pending Confirmations',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },

  // Documents
  {
    path: '/organization/documents',
    name: 'organization-document-list',
    component: () => import('@/views/organization/document/list/List.vue'),
    meta: {
      pageTitle: 'List all documents',
      breadcrumb: [
        {
          text: 'Documents',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/document/add',
    name: 'organization-document-add',
    component: () => import('@/views/organization/document/add/Add.vue'),
    meta: {
      pageTitle: 'Add a new Document',
      breadcrumb: [
        {
          text: 'Documents',
          to: '/organization/documents',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/document/edit/:id',
    name: 'organization-document-edit',
    component: () => import('@/views/organization/document/edit/Edit.vue'),
    meta: {
      pageTitle: 'Edit this Document',
      breadcrumb: [
        {
          text: 'Documents',
          to: '/organization/documents',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/qr-generator/list',
    name: 'organization-qr-generator-list',
    component: () => import('@/views/organization/qr-generator/list/List.vue'),
    meta: {
      pageTitle: 'List all QR code',
      breadcrumb: [
        {
          text: 'QR Codes',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/qr-generator/add',
    name: 'organization-qr-generator-add',
    component: () => import('@/views/organization/qr-generator/add/Add.vue'),
    meta: {
      pageTitle: 'Create QR',
      breadcrumb: [
        {
          text: 'QR Codes',
          to: '/organization/qr-generator/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Values add / edit
  {
    path: '/organization/value/add',
    name: 'organization-value-add',
    component: () => import('@/views/organization/value/add/Add.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Add a new Value',
      breadcrumb: [
        {
          text: 'Values',
          to: '/organization/value/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/value/edit/:id',
    name: 'organization-value-edit',
    component: () => import('@/views/organization/value/edit/Edit.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Edit this Value',
      breadcrumb: [
        {
          text: 'Values',
          to: '/organization/value/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Behaviours
  {
    path: '/organization/behaviour/list',
    name: 'organization-behaviour-list',
    component: () => import('@/views/organization/behaviour/list/List.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Behaviours',
      breadcrumb: [
        {
          text: 'Behaviours',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/behaviour/add',
    name: 'organization-behaviour-add',
    component: () => import('@/views/organization/behaviour/add/Add.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Add a new Behaviour',
      breadcrumb: [
        {
          text: 'Behaviours',
          to: '/organization/behaviour/list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/behaviour/edit/:id',
    name: 'organization-behaviour-edit',
    component: () => import('@/views/organization/behaviour/edit/Edit.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Edit this Behaviour',
      breadcrumb: [
        {
          text: 'Behaviours',
          to: '/organization/behaviour/list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Values
  {
    path: '/organization/value/list',
    name: 'organization-value-list',
    component: () => import('@/views/organization/value/list/List.vue'),
    beforeEnter: (_, __, next) => (getBehaviorFunctionalityDD() ? next() : next({ name: 'misc-not-authorized' })),
    meta: {
      pageTitle: 'Values',
      breadcrumb: [
        {
          text: 'Values',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
